import { Observable } from 'rxjs';
import { PaymentRequest, PaymentStatusResponse } from '@core/models/payment';
/**
 * Abstract payment gateway interface
 * All payment providers must implement this interface
 */
export abstract class IPaymentGateway {
  /**
   * Create a payment request
   * @param request Payment request details
   */
  abstract createPaymentRequest(request: PaymentRequest): Observable<any>;

  /**
   * Set processor information for a payment request
   * @param requestId Payment request ID
   * @param gatewayId Payment gateway ID
   * @param terminalId Terminal ID (optional)
   */
  abstract setPaymentProcessor(requestId: string, gatewayId: string, terminalId?: string): Observable<any>;

  /**
   * Send payment request to the terminal/provider
   * @param requestId Payment request ID
   * @param gatewayId Payment gateway ID
   * @param terminalId Terminal ID (optional)
   */
  abstract sendPaymentToTerminal(requestId: string, gatewayId: string, terminalId?: string): Observable<any>;

  /**
   * Check the payment status (polling)
   * @param requestId Payment request
   * @param gatewayId Payment gateway
   * @param terminalId Terminal ID (optional)
   * @param processorId Processor ID (optional)
   */
  abstract checkPaymentStatus(requestId: string, gatewayId: string, terminalId?: string, processorId?: string): Observable<PaymentStatusResponse>;
}

